import { YoutubeRankData } from '@/pages/youtube/youtubeRankItem'
import './mainYoutubeMobile.css'
import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'

interface MobileListItemProps {
  data: YoutubeRankData[]
  setLikeStatus?: (
    formData: FormData,
    chnlId: string,
    currentLikeStatus: string,
  ) => void
}

export const MainYoutubeMobile: React.FC<MobileListItemProps> = ({
  data,
  setLikeStatus,
}) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth)
  const { showAlert } = useDialog()

  const [likesState, setLikesState] = useState(
    data.reduce(
      (acc, item) => {
        acc[item.chnlId] = isAuthenticated ? item.userLikeYn || 'N' : 'N'
        return acc
      },
      {} as Record<string, string>,
    ),
  )

  const formatSubscribers = (num: number): string => {
    if (num >= 10000) {
      return (num / 10000).toFixed(1) + '만'
    }
    return num.toLocaleString()
  }

  const formatVideos = (num: number): string => {
    if (num >= 1000) {
      return Math.floor(num / 100) / 10 + '천'
    }
    return num.toLocaleString()
  }

  const openYouTubeChannel = (chnlId: string) => {
    const url = `https://www.youtube.com/channel/${chnlId}`
    window.open(url, '_blank')
  }

  const handleClick = (chnlId: string) => {
    if (!isAuthenticated) {
      showAlert({
        type: 'error',
        title: '로그인 후 좋아요를 눌러주세요.',
      })
      return
    }
    const newLikesYn = likesState[chnlId] === 'Y' ? 'N' : 'Y'

    setLikesState((prevState) => ({
      ...prevState,
      [chnlId]: newLikesYn,
    }))

    if (user?.cstId) {
      const formData = new FormData()
      formData.append('cstId', user.cstId)
      formData.append('chnlId', chnlId)
      formData.append('likesYn', newLikesYn)
      setLikeStatus?.(formData, chnlId, likesState[chnlId])
    } else {
      showAlert({
        type: 'error',
        title: '로그인 후 좋아요를 눌러주세요.',
      })
    }
  }

  // 모바일용: 3개씩 그룹화
  const groupedData = []
  for (let i = 0; i < data.length; i += 3) {
    groupedData.push(data.slice(i, i + 3))
  }

  return (
    <div className="mobile-youtube-container">
      <Swiper
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mobile-swiper-container"
      >
        {groupedData.map((group, groupIndex) => (
          <SwiperSlide key={groupIndex}>
            <div className="mobile-slide-group">
              {group.map((item) => (
                <div className="mobile-ranking-item" key={item.chnlId}>
                  <div className="mobile-rank">{item.chnlRank}</div>
                  <div
                    className="mobile-logo"
                    onClick={() => openYouTubeChannel(item.chnlId)}
                  >
                    <img src={item.thumbnailsDefault} alt={item.title} />
                  </div>
                  <div
                    className="mobile-channel-info"
                    onClick={() => openYouTubeChannel(item.chnlId)}
                  >
                    <div className="mobile-channel-name">{item.title}</div>
                    <div className="mobile-subscribers">
                      {`구독자 ${formatSubscribers(item.subscriberCount)}명`}
                    </div>
                    <div className="mobile-video-count">
                      {`동영상 ${formatVideos(item.videoCount)}개`}
                    </div>
                  </div>
                  <div className="mobile-likes">
                    <svg
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => handleClick(item.chnlId)}
                      className="mobile-heart-icon"
                    >
                      <g data-name="Layer 1" id="Layer_1">
                        <path
                          d="M16 29s13-8.35 13-14.15c0-5.03-3.4-8.66-7.5-8.66-2.86 0-4.91 2.11-5.5 3.56-0.59-1.45-2.64-3.56-5.5-3.56-4.1 0-7.5 3.63-7.5 8.66C3 20.65 16 29 16 29z"
                          fill={
                            likesState[item.chnlId] === 'Y'
                              ? '#ff0000'
                              : 'none'
                          }
                          stroke={
                            likesState[item.chnlId] === 'Y'
                              ? 'none'
                              : '#101820'
                          }
                          strokeWidth="2"
                        />
                      </g>
                    </svg>
                    <div className="mobile-like-count">
                      {formatVideos(item.likeCount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}